import React, { useState, useEffect, useRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import axios from "axios";
import { Search } from "lucide-react";
import Modal from "../components/common/CommonModal";
import CreditCustomerList from "../components/common/CreditCustomerList";

const Group1Selector = ({
  accounts,
  value,
  setValue,
  onSelectedAccountParent,
}) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const inputRef = useRef(null);
  const [inputValue1, setInputValue1] = useState("-");
  const [filteredAccounts, setFilteredAccounts] = useState(null);
  const [filteredSearchedAccounts, setFilteredSearchedAccounts] =
    useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);
  const [selectedGroup1, setSelectedGroup1] = useState(null);
  const [accountListFromAPI, setAccountListFromAPI] = useState(null);
  const [searchGroup1Term, setSearchGroup1Term] = useState(null);
  const [selectedGroup1Account, setSelectedGroup1Account] = useState(null);

  // const [value, setValue] = useState("ALL");

  useEffect(() => {
    fetchAccountList();
  }, []);

  useEffect(() => {
    setFilteredAccounts(accountListFromAPI);
  }, [accountListFromAPI]);

  useEffect(() => {
    if (!searchGroup1Term?.trim()) {
      setFilteredSearchedAccounts(filteredAccounts);
    } else {
      const term = searchGroup1Term.toLowerCase();
      setFilteredSearchedAccounts(
        filteredAccounts?.filter(
          (acc) =>
            acc.GRP_CODE?.toLowerCase().includes(term) ||
            acc.DESCRIPTION?.toLowerCase().includes(term),
        ),
      );
    }
  }, [searchGroup1Term, filteredAccounts]);

  const fetchAccountList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/ACCOUNTGROUP/-/-`;
    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      // console.log("fetched Account List :", data);
      setAccountListFromAPI(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    setFilteredAccounts(accountListFromAPI);
  }, [accountListFromAPI]);

  // Filter accounts when typing
  // useEffect(() => {
  //   if (!inputValue1.trim()) {
  //     setFilteredAccounts(accounts);
  //   } else {
  //     // console.log('accounts::',accounts)
  //     setFilteredAccounts(
  //       accounts?.filter(
  //         (acc) =>
  //           acc.DESCRIPTION?.toLowerCase().includes(inputValue1.toLowerCase()) ||
  //           acc.GRP_CODE?.toLowerCase().includes(inputValue1.toLowerCase())
  //       )
  //     );
  //   }
  // }, [inputValue1, accounts]);

  useEffect(() => {
    if (!inputValue1.trim()) {
      setFilteredAccounts(accountListFromAPI ?? []);
    } else {
      const term = inputValue1.toLowerCase();
      setFilteredAccounts(
        (accountListFromAPI ?? []).filter(
          (acc) =>
            acc.DESCRIPTION?.toLowerCase().includes(term) ||
            acc.GRP_CODE?.toLowerCase().includes(term),
        ),
      );
    }
  }, [inputValue1, accountListFromAPI]);

  // console.log("filteredAccounts:", filteredAccounts);
  // console.log("selectedGroup1:", selectedGroup1);

  // Open modal on F2 press
  // useEffect(() => {
  //   const handleKeyDown1 = (e) => {
  //     if (e.key === "F2" && document.activeElement === inputRef.current) {
  //       e.preventDefault();
  //       setModalOpen1(true);
  //     }
  //   };
  //   window.addEventListener("keydown", handleKeyDown1);
  //   return () => window.removeEventListener("keydown", handleKeyDown1);
  // }, []);

  const clearAccounts = () => {
    setInputValue1("-");
    setSelectedGroup1(null);
    onSelectedAccountParent("-");
  };

  const sendAccountToParent = (acc) => {
    console.log("sendAccountToParent acc", acc);
    onSelectedAccountParent(acc);
  };

  const [highlightedIndex, setHighlightedIndex] = useState(0);

  useEffect(() => {
    if (!isModalOpen1) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          Math.min(prev + 1, filteredSearchedAccounts?.length - 1),
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedIndex((prev) => Math.max(prev - 1, 0));
      } else if (e.key === "Enter") {
        e.preventDefault();
        const selected = filteredSearchedAccounts[highlightedIndex];
        if (selected) {
          setInputValue1(`${selected.GRP_CODE} - ${selected.DESCRIPTION}`);
          setSelectedGroup1(selected);
          setModalOpen1(false);
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        setModalOpen1(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen1, highlightedIndex, filteredSearchedAccounts]);

  const closeModal = () => {
    setSearchGroup1Term(""); // reset search
    setModalOpen1(false);
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F2" && document.activeElement === inputRef.current) {
        e.preventDefault();
        setModalOpen(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleCustomerSelect = (data) => {
    console.log("data:", data);
    setSelectedAccount(data);
    onSelectedAccountParent(data.ACCOUNT);
    // setModalOpen1(false);
    setModalOpen(false);

    setInputValue1(`${data.ACCOUNT} - ${data.DESCRIPTION}`);
    setSelectedGroup1(data);
    onSelectedAccountParent(data.ACCOUNT);
    // onSelectedAccountParent(data.GRP_CODE);
  };

  console.log("SelectedGroup1:", selectedGroup1);

  return (
    <div className="relative w-[380px]">
      <div className="flex justify-between bg-white items-center w-full border border-gray-300 rounded px-3 py-1">
        <input
          type="text"
          ref={inputRef}
          // value={inputValue1}
          value={inputValue1 === "-" ? "" : inputValue1}
          placeholder="Select or type Group 1"
          onChange={(e) => {
            setInputValue1(e.target.value);
            setDropdownOpen(true);
          }}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
          className="w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0"
        />
        {/* {inputValue1 && ( */}
        {inputValue1 !== "" && inputValue1 !== "-" && (
          <button
            className="rounded text-gray-800"
            onClick={() => {
              setInputValue1("");
              setSelectedGroup1(null);
              onSelectedAccountParent("-");
            }}
          >
            <ClearIcon fontSize="small" />
          </button>
        )}
      </div>

      {/* Dropdown */}
      {isDropdownOpen && filteredAccounts.length > 0 && (
        <ul
          className="absolute bg-white border border-gray-300 w-full mt-1 max-h-44 shadow-lg overflow-y-auto z-10 rounded-md"
          onMouseDown={(e) => e.preventDefault()}
        >
          {filteredAccounts.map((acc, i) => (
            <li
              key={i}
              onClick={() => {
                setInputValue1(`${acc.GRP_CODE} - ${acc.DESCRIPTION}`);
                setSelectedGroup1(acc);
                setDropdownOpen(false);
                sendAccountToParent(acc.GRP_CODE);
              }}
              className="px-3 py-2 text-sm text-gray-700 hover:bg-blue-100 cursor-pointer "
            >
              <div className="flex flex-col border-b pb-1">
                <span className="font-medium">{acc.GRP_CODE}</span>
                <span className="text-xs text-gray-500 truncate">
                  {acc.DESCRIPTION}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}

      {/* Modal */}
      {/* // <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"> */}
      {/* // <div className="bg-white rounded-2xl shadow-2xl flex flex-col w-full max-w-2xl mx-4 sm:mx-6 h-[70vh] overflow-hidden"> */}
      {/* Header */}
      {isModalOpen1 && (
        <Modal
          isOpen={isModalOpen1}
          onClose={() => setModalOpen1(false)}
          title={"Select Group 1"}
          // size="xxl"
          header={true}
        >
          <div className="flex justify-between items-center py-3 px-5 border-b border-gray-200 bg-gray-50 sticky top-0 z-20">
            {/* <h2 className="text-lg font-semibold text-gray-800">Select Group 1</h2> */}
            <div className="relative flex-1 mx-4">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                className="w-full pl-10 pr-10 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm placeholder-gray-400"
                type="text"
                placeholder="Search Group 1"
                value={searchGroup1Term}
                onChange={(e) => setSearchGroup1Term(e.target.value)}
                aria-label="Search Group 1"
              />
              {searchGroup1Term && (
                <button
                  type="button"
                  onClick={() => setSearchGroup1Term("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                  aria-label="Clear search"
                >
                  <ClearIcon fontSize="small" />
                </button>
              )}
            </div>
            {/* <button
            className="p-2 rounded-full hover:bg-gray-200 transition-colors"
            onClick={closeModal}
            aria-label="Close modal"
          >
            <ClearIcon fontSize="small" className="text-gray-600" />
          </button> */}
          </div>

          {/* Table */}
          <div className="flex-1 overflow-y-auto">
            <table className="min-w-full table-auto border-collapse">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b border-gray-200">
                    Group Code
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b border-gray-200">
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* {(filteredSearchedAccounts ?? accountListFromAPI)?.map((acc, i) => ( */}
                {filteredSearchedAccounts?.map((acc, i) => (
                  <tr
                    key={i}
                    onClick={() => {
                      setInputValue1(`${acc.GRP_CODE} - ${acc.DESCRIPTION}`);
                      setSelectedGroup1(acc);
                      onSelectedAccountParent(acc.GRP_CODE);
                      setModalOpen1(false);
                    }}
                    className={`cursor-pointer transition-colors duration-150 ${
                      highlightedIndex === i
                        ? "bg-blue-100"
                        : "hover:bg-blue-50"
                    }`}
                  >
                    <td className="text-sm px-4 py-2 border-b border-gray-200 text-gray-700">
                      {acc.GRP_CODE}
                    </td>
                    <td className="text-sm px-4 py-2 border-b border-gray-200 text-gray-600">
                      {acc.DESCRIPTION}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal>
      )}

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          title={"Statement Account"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleCustomerSelect}
          />
          {/* <ProductListing/> */}
        </Modal>
      )}
    </div>
  );
};

export default Group1Selector;
